<template>
    <v-content>
        <v-app>
            <v-container grid-list-md text-xs-center fluid>
                <v-layout row wrap>
                    <v-flex xs4 class="text-xs-left">
                        <v-select v-model="merchantUuid" @change="getUsers()" :items="merchants" item-text="name" item-value="uuid" label="Companies"></v-select>
                    </v-flex>
                </v-layout>

                <v-layout v-if="merchantUuid" row wrap align-center>
                    <v-flex xs12>
                        <v-data-table class="elevation-1" :headers="tableHeaders" :items="users" item-key="id" :rows-per-page-items="rowsPerPage" :loading="loading">
                            <template v-slot:items="props">
                                <td class="text-xs-left">{{ props.item.username }}</td>
                                <td class="text-xs-left">{{ props.item.first_name }}</td>
                                <td class="text-xs-left">{{ props.item.surname }}</td>
                                <td class="text-xs-left">{{ props.item.pages }}</td>
                                <td v-html="props.item.subPages" class="text-xs-left"></td>
                                <td class="text-xs-left">
                                    <v-btn icon @click="editUser(props.item)">
                                        <v-icon color="grey">mdi-account-edit</v-icon>
                                    </v-btn>         
                                </td>
                            </template>
                        </v-data-table>
                        <edit-user
                            :visible="dialog"
                            :userData="userData"
                            :merchants="merchants"
                            :users="users"
                            :pageAccess="pageAccess"
                            :subPageAccess="subPageAccess"
                            @closeDialog="dialog = false"
                            @getUsers="getUsers()">
                        </edit-user>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-app>
    </v-content>
</template>

<script>
import axios from 'axios';
import sweetAlert from '../sweetAlert.js';
import EditUserDialog from '../components/EditUserDialog.vue';

export default {
    data() {
        return { 
            form: false,
            loading: true,
            rules: { required: [ v => !!v || 'Required' ],
                     email: [ v => this.emailRule(v) ],
                     multiSelect: [ v => this.multiSelect(v) ],
                     username: [ v => this.username(v) ] },
            merchantUuid: null,
            merchants: [],
            users: [],
            dialog: false,
            userData: null,
            rowsPerPage:[10, 25, 50, 100],
            tableHeaders: [ { text: 'Username', value: 'username', sortable: false },
                            { text: 'First Name', value: 'first_name', sortable: false },
                            { text: 'Surname', value: 'surname', sortable: false },
                            { text: 'Pages', value: 'pages', sortable: false },
                            { text: 'Sub Pages', value: 'subpages', sortable: false },
                            { text: 'Edit User', sortable: false, align: 'center' } ],
            pageAccess: null,
            subPageAccess: null
        }
    },
    components: {
        'edit-user': EditUserDialog
    },
    mixins: [ sweetAlert ],
    beforeMount() {
        this.getMerchants();
        this.getUsers();
        this.getPageAccess();
        this.getSubPageAccess();
    },
    methods: {
        getUsers() {
            this.loading = true;
            this.dialog = false;

            axios({
            method: 'post',
            data: { merchantUuid: this.merchantUuid, userId: localStorage.user_id },
            url: 'https://controlapi.totalprocessing.com/api/get-users-access-table',
            config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
            })
            .then(response => {
                this.users = response.data.filter(e => e.merchant_access.indexOf(this.merchantUuid) != -1);
                this.loading = false;
            })
            .catch(e => {
                this.errors.push(e)
            })
        },
        getMerchants() {
            axios({
            method: 'post',
            data: { userId: localStorage.user_id },
            url: 'https://controlapi.totalprocessing.com/api/client-get-merchant',
            config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
            })
            .then(response => {
                this.merchants = response.data;
            })
            .catch(e => {
                this.errors.push(e)
            })
        },
        editUser(user) {
            this.userData = user;
            this.dialog = true;
        },
        getPageAccess() {
            axios({
            method: 'post',
            data: { userId: localStorage.user_id },
            url: 'https://controlapi.totalprocessing.com/api/get-page-access',
            config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
            })
            .then(response => {
                this.pageAccess = response.data;
            })
            .catch(e => {
                this.errors.push(e)
            })
        },
        getSubPageAccess() {
            axios({
            method: 'post',
            data: { userId: localStorage.user_id },
            url: 'https://controlapi.totalprocessing.com/api/get-sub-page-access',
            config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
            })
            .then(response => {
                this.subPageAccess = response.data;

                this.subPageAccess.map(e => {
                    e.sub_page_name = `${e.page_name} - ${e.sub_page_name}`;
                });
            })
            .catch(e => {
                this.errors.push(e)
            })
        },
        onSubmit() {
            if(this.$refs.form.validate()) {
                let temp = [];
                if(this.form.subPageAccess) {
                    this.form.subPageAccess.map((i) => {
                        if(!this.form.pageAccess.includes(i.parent_id)) {
                            this.form.pageAccess.push(i.parent_id);
                        }
                        temp.push(i.sub_page_access);
                    });
                }
                this.form.pageAccess.push(1,10);
                this.form.pageAccessComma = this.form.pageAccess.join(",");
                this.form.subPageAccessComma = temp ? temp.join(",") : null;
                this.form.merchantUuidComma = this.form.merchantUuid.join('","');
                
                axios({
                method: 'post',
                data: { form: this.form },
                url: 'https://controlapi.totalprocessing.com/api/create-user',
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    let result = {};
                    if(response.status == 201) {
                        result.user = 'add-user-success';
                        this.sweetAlert(result);
                        this.$refs.form.reset();
                    }
                    else {
                        result.user = 'add-user-failed';
                        this.sweetAlert(result);
                    }
                })
                .catch(e => {
                    this.errors.push(e)
                })
            }
        },
        emailRule(v) {
            let pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

            if(typeof v !== 'undefined' && v)
            {   if(!pattern.test(v)) {
                    return 'Invalid Email address';
                }
                else { 
                    return true;
                }
            } 
            else {
                return true;
            }
        },
        multiSelect(v) {
            return v.length > 0 ? true : 'Required';
        },
        username(v) {
            return this.users.find(user => user.username.toLowerCase() === v) ? 'Username already exists' : this.emailRule(v);
        }
    }
}
</script>

<style>

</style>